import { createSlice, createAsyncThunk, current, PayloadAction } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import getConfig from "../app/config";
import fetchWithRefresh from "./fetchWithRefresh";

export const getFeatureToggles = createAsyncThunk<any, void>(
    "feature-toggles/getFeatureToggles",
    async (arg) => {      
      return await fetchWithRefresh(getConfig().apiUrl + `featureToggle`);
    }
);

export const getFeatureToggle = createAsyncThunk<any, number>(
    "feature-toggles/getFeatureToggle",
    async (featureToggleId) => {
      return await fetchWithRefresh(getConfig().apiUrl + `featureToggle/${featureToggleId}`);
    }
);

export const enableFeatureToggle = createAsyncThunk<any, { featureToggleId: string }>(
  "feature-toggles/enableFeatureToggle",
  async ({ featureToggleId }) => {
    return await fetchWithRefresh(getConfig().apiUrl + `featureToggle/${featureToggleId}/enable`, {
      method: "PUT",
       headers: { "Content-Type": "application/json", Accept: "application/json" },
    });
  }
);

export const updateFeatureToggle = createAsyncThunk<any, { featureToggle: FeatureToggleInfo, id: number }>(
  "feature-toggles/updateFeatureToggle",
  async ({ featureToggle, id }, thunkApi) => {    
    return await fetchWithRefresh(getConfig().apiUrl + `featureToggle/${id}`, thunkApi, {
      method: "PUT",
       headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(featureToggle)
    });
  }
);

export const getAllUsers = createAsyncThunk<any, void>(
    "feature-toggles/getAllUsers",
    async () => {
      return await fetchWithRefresh(getConfig().apiUrl + `user/all`);
    }
);

export interface FeatureTogglesOverviewInfo {
    id: number,
    name: string,
    enabled: boolean
  }

  export interface FeatureToggleInfo {
    id: number,
    name: string,
    enabled: boolean,
    enabledUserIds: number[],
  }

  export interface UserInfo {
    id: number,
    name: string,
    emailAddress: string
  }

export interface FeatureTogglesState {
    featureTogglesLoading: boolean,
    usersLoading: boolean,
    featureToggles: FeatureTogglesOverviewInfo[],
    featureToggle: FeatureToggleInfo | null,
    error: any,
    users: UserInfo[]
  }
  
  const initialState: FeatureTogglesState = {
    featureTogglesLoading: false,
    usersLoading: false,
    featureToggles: [],
    featureToggle: null,
    error: null,
    users: []
  }

const featureTogglesSlice = createSlice({
    name: 'feature-toggles',
    initialState,
    reducers: {            
      // updateFeatureToggle: (state, action: PayloadAction<any>) => {
      //   const { id, changes } = action.payload;
      //   const featureToggle = state.featureToggles.find((f) => f.id === id);
      //   if (featureToggle) {
      //     Object.assign(featureToggle, changes);
      //   }
      // }
    },
    extraReducers:  (builder) => {
        builder.addCase(getFeatureToggles.pending, (state, { payload }) => {
            state.featureTogglesLoading = true;
          });
        builder.addCase(getFeatureToggles.fulfilled, (state, { payload }) => {
            state.featureTogglesLoading = false;
            if (!payload.success) {
              if (payload.errors.status === 403) {
                toast.error("You are not authorized to perform this action.");
                state.error = payload.errors;// { "Error" : "You are not authorized to perform this action."};
              } else {
                state.error = payload.errors;
              }             
            } else {
              state.featureToggles = payload.featureToggles;              
            }
          });
        builder.addCase(getFeatureToggles.rejected, (state, action) => {
              state.featureTogglesLoading = false;
            state.error = action?.payload ?? action.error;
          });

        builder.addCase(getFeatureToggle.pending, (state, { payload }) => {
            state.featureTogglesLoading = true;
            state.featureToggle = null;
          });
        builder.addCase(getFeatureToggle.fulfilled, (state, { payload }) => {          
            state.featureTogglesLoading = false;
            if (!payload.success) {
              if (payload.errors.status === 403) {
                toast.error("You are not authorized to perform this action.");
                state.error = payload.errors;// { "Error" : "You are not authorized to perform this action."};
              } else {
                state.error = payload.errors;
              }             
            } else {
              state.featureToggle = payload;              
            }
          });
        builder.addCase(getFeatureToggle.rejected, (state, action) => {
              state.featureTogglesLoading = false;
            state.error = action?.payload ?? action.error;
          });

        builder.addCase(updateFeatureToggle.pending, (state, { payload }) => {
            state.featureTogglesLoading = true;            
          });
        builder.addCase(updateFeatureToggle.fulfilled, (state, { payload }) => {          
            state.featureTogglesLoading = false;
            if (!payload.success) {
              if (payload.errors.status === 403) {
                toast.error("You are not authorized to perform this action.");
                state.error = payload.errors;// { "Error" : "You are not authorized to perform this action."};
              } else {
                state.error = payload.errors;
              }             
            }
          });
        builder.addCase(updateFeatureToggle.rejected, (state, action) => {
            state.featureTogglesLoading = false;
            state.error = action?.payload ?? action.error;
          });

        builder.addCase(getAllUsers.pending, (state, { payload }) => {
            state.usersLoading = true;
          });
        builder.addCase(getAllUsers.fulfilled, (state, { payload }) => {
            state.usersLoading = false;
            if (!payload.success) {
              if (payload.errors.status === 403) {
                toast.error("You are not authorized to perform this action.");
                state.error = payload.errors;// { "Error" : "You are not authorized to perform this action."};
              } else {
                state.error = payload.errors;
              }             
            } else {
              state.users = payload.users;
            }
          });
        builder.addCase(getAllUsers.rejected, (state, action) => {
            state.usersLoading = false;
            state.error = action?.payload ?? action.error;
          });
    }    
})

export const { 
              
               } = featureTogglesSlice.actions

export default featureTogglesSlice.reducer;